import React from 'react';
import { Link } from 'react-router-dom';

import { Row, Col } from 'antd';

import { URL_SELECT } from 'settings';
import type { IUserData } from 'v2/interfaces/user';

import { WithQualificationValidation } from './withQualificationValidation';

export type QuickStartProps = {
  user: IUserData;
};

function QuickStart({ user }: QuickStartProps) {
  return (
    <div className='mx-auto w-[80vw] max-w-225 rounded-sm p-16 text-center transition-opacity duration-500'>
      <div className='text-text-heading text-center'>
        <h1 className='text-text-heading mb-6! text-xl'>Olá, {user.name}</h1>
        <span>
          Agora que você é Parceiro Eduzz, está pronto para iniciar seu trabalho, seja como afiliado ou produtor de
          conteúdos digitais.Escolha abaixo por onde deseja começar.
        </span>
      </div>

      <div className='mt-4' />

      <Row gutter={[16, 16]}>
        <Col md={12} xs={24}>
          <Link to={'/producer/product/newproduct'}>
            <button className='text-text-secondary flex max-h-75 min-h-37.5 w-full cursor-pointer flex-col items-center justify-center border border-[#e8e8e8] bg-white p-7 text-[15px] hover:bg-[rgba(248,248,248,0.6)] hover:shadow-[0_2px_2px_0_rgba(0,0,0,.18),0_13px_24px_0_hsla(0,0%,62%,.1)] [&_strong]:mb-1 [&_strong]:flex [&_strong]:items-center [&_strong]:justify-center [&_strong]:font-semibold [&_strong_img]:ml-1.5'>
              <strong>Cadastre seu produto</strong>
              <span>
                Venda cursos online,e-books, softwares, ingressos para eventos, musicas ou qualquer outro tipo de
                produto digital.
              </span>
            </button>
          </Link>
        </Col>
        <Col md={12} xs={24}>
          <a href={URL_SELECT}>
            <button className='text-text-secondary flex max-h-75 min-h-37.5 w-full cursor-pointer flex-col items-center justify-center border border-[#e8e8e8] bg-white p-7 text-[15px] hover:bg-[rgba(248,248,248,0.6)] hover:shadow-[0_2px_2px_0_rgba(0,0,0,.18),0_13px_24px_0_hsla(0,0%,62%,.1)] [&_strong]:mb-1 [&_strong]:flex [&_strong]:items-center [&_strong]:justify-center [&_strong]:font-semibold [&_strong_img]:ml-1.5'>
              <strong>Afilie-se a um produto</strong>
              <span>
                Entre em nossa vitrine, escolha um produto para se afiliar e promova-o em troca de comissões por cada
                venda
              </span>
            </button>
          </a>
        </Col>
        <Col md={12} xs={24}>
          <a
            target='_blank'
            rel='noopener noreferrer'
            href={'https://academia360.eduzz.com/cursos?utm_source=orbita&utm_medium=quickstart'}
          >
            <button className='text-text-secondary flex max-h-75 min-h-37.5 w-full cursor-pointer flex-col items-center justify-center border border-[#e8e8e8] bg-white p-7 text-[15px] hover:bg-[rgba(248,248,248,0.6)] hover:shadow-[0_2px_2px_0_rgba(0,0,0,.18),0_13px_24px_0_hsla(0,0%,62%,.1)] [&_strong]:mb-1 [&_strong]:flex [&_strong]:items-center [&_strong]:justify-center [&_strong]:font-semibold [&_strong_img]:ml-1.5'>
              <strong>Primeiros passos no Marketing Digital</strong>
              <span>
                Aprenda a melhor forma de se tornar um empreendedor digital e fazer vendas com os cursos gratuitos da
                Academia 360.
              </span>
            </button>
          </a>
        </Col>
        <Col md={12} xs={24}>
          <Link to={'/producer/news/list'}>
            <button className='text-text-secondary flex max-h-75 min-h-37.5 w-full cursor-pointer flex-col items-center justify-center border border-[#e8e8e8] bg-white p-7 text-[15px] hover:bg-[rgba(248,248,248,0.6)] hover:shadow-[0_2px_2px_0_rgba(0,0,0,.18),0_13px_24px_0_hsla(0,0%,62%,.1)] [&_strong]:mb-1 [&_strong]:flex [&_strong]:items-center [&_strong]:justify-center [&_strong]:font-semibold [&_strong_img]:ml-1.5'>
              <strong>Novidades</strong>
              <span>
                Fique por dentro das principais novidades que estão acontecendo no Orbita e nas outras plataforma da
                Eduzz!
              </span>
            </button>
          </Link>
        </Col>
      </Row>
    </div>
  );
}

export default WithQualificationValidation(QuickStart);
